import React from 'react'
import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import cx from 'classnames'
import styles from './spinner-style.css'

const propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  color: PropTypes.oneOf(['white', 'primary']),
}

// Add any default values for props
const defaultProps = {
  size: 'medium',
  color: 'primary',
}

function Spinner({ size, color }) {
  return (
    <div className={cx(styles[size], styles[color], styles.spinner)}>
      <svg className={styles.circular} viewBox="25 25 50 50">
        <circle
          className={styles.path}
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </svg>
    </div>
  )
}

Spinner.displayName = 'Spinner'
Spinner.propTypes = propTypes
Spinner.defaultProps = defaultProps

export default Spinner



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js